var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+": "),_c('span',{class:_vm.paymentAllStatus.isPaid || _vm.isCashOnDelivery
        ? 'provider-font-color'
        : _vm.paymentAllStatus.isPaid == null
        ? ''
        : 'red--text'},[(_vm.orderData.payment_type)?[_vm._v(" "+_vm._s(_vm.$t(("data.payment_type." + (_vm.orderData.payment_type))))+" ")]:_vm._e(),(!_vm.isCashOnDelivery && _vm.paymentAllStatus.isUnpaid !== null)?[_vm._v(" "+_vm._s(_vm.paymentStatusText)+" ")]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }